define("shared/utils/analytics/constants/index", ["exports", "shared/utils/analytics/constants/features"], function (_exports, _features) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "FEATURES", {
    enumerable: true,
    get: function () {
      return _features.default;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"shared/utils/analytics/constants/features"eaimeta@70e063a35619d71f
});